module.exports = __webpack_public_path__ + "media/images/cms/logo_app-fa2e303fe22a2be81fc23524dd4279f2.svg";